export default Object.freeze({
  EXIT: 1,
  DISCIPLINE: 2,
  CHILD_COUNT: 3,
  PERSONNEL: 4,
  StudenVisualImpairments: 5,
})
